﻿import { toggleVisibility } from '../utils';

const SELECTORS = {
    accordion: '.accordion',
    toggleIcons: '.accordion-expand, .accordion-collapse',
    toggle: '.accordion-toggle',
    button: '.accordion-button',
    expand: '.accordion-expand',
    collapse: '.accordion-collapse',
};

const DATA_OPEN_ACTIVE = 'open-active';
const DATA_COLLAPSE = 'collapse';
const PRIMARY_CLASS = 'accordion-primary';

function toggleAccordion($accordion: JQuery<HTMLElement>, $btn: JQuery<HTMLElement>, state?: boolean): void {
    const expanded = $btn.attr('aria-expanded') == 'true';

    if (typeof state !== 'boolean') {
        state = !expanded;
    } else if (expanded === state) {
        return;
    }

    const target = $btn.data('target');
    const $submenu = $accordion.find('#' + target);

    if ($accordion.hasClass(PRIMARY_CLASS)) {
        // Primary variant, used in the FAQ blocks
        $btn.toggleClass(['bg-primary', 'text-white', 'hover:bg-tertiary'], state);
    }

    toggleVisibility($btn.find(SELECTORS.collapse), state);
    toggleVisibility($btn.find(SELECTORS.expand), !state);

    $btn.attr('aria-expanded', String(state));
    $submenu.slideToggle(200).toggleClass('open');
}

function onClick(e: JQuery.ClickEvent | JQuery.KeyDownEvent): void {
    e.stopPropagation();
    const $btn = $(e.currentTarget);
    const $accordion = $btn.closest(SELECTORS.accordion);
    const expanded = $btn.attr('aria-expanded') == 'true';
    const collapse = $accordion.data(DATA_COLLAPSE) ?? true;

    toggleAccordion($accordion, $btn, !expanded);

    // Close sibling accordions when opening
    // TODO: if !expanded && closeSiblings
    if (!expanded && collapse) {
        $accordion
            .siblings(SELECTORS.accordion)
            .each((_, el) => {
                const $accordion = $(el);
                const $btn = $accordion.children('.accordion-header').find(SELECTORS.toggle);

                toggleAccordion($accordion, $btn, false);
            });
    }
}

/*
 * Accordion menu
 * Make accordion fully WCAG compatible
 */
export function registerAccordions(): void {
    const $accordion = $(SELECTORS.accordion);

    $accordion
        .find(SELECTORS.toggle)
        .on('click', (e) => {
            const $target = $(e.target);

            // if .accordion-toggle is a, check if in SELECTORS.button, otherwise always allow
            // If toggle button was clicked, prevent going to link destination, instead open the menu
            if (e.currentTarget.tagName == 'A' && !$target.closest(SELECTORS.button).length) {
                return;
            }

            onClick(e);
            return e.preventDefault();
        })
        .on('keydown', (e) => {
            if (e.key == ' ' || e.key == 'Spacebar') {
                onClick(e);
                return e.preventDefault();
            }
        });

    // Open active accordions on load
    $accordion
        .filter('.active')
        .each((_, el) => {
            const $el = $(el);
            if ($el.data(DATA_OPEN_ACTIVE)) {
                $el.find(SELECTORS.button).first().click();
            }
        });
}